import { Page } from 'shared/Page'
import { StandaloneThemeProvider } from 'theme/standalone/StandaloneThemeProvider'

import { BaseLayout } from './BaseLayout'

type DefaultLayoutProps = {
  children: React.ReactNode
}

export const StandaloneLayout = ({ children }: DefaultLayoutProps) => {
  return (
    <BaseLayout>
      <StandaloneThemeProvider>
        <Page>
          <Page.Content>{children}</Page.Content>
        </Page>
      </StandaloneThemeProvider>
    </BaseLayout>
  )
}
